export const axiosDefaultTimeout = 15; // seconds

export const defaultLang = 'en';

const rawLanguages = process.env.REACT_APP_LANGUAGES || 'en,ru';
export const availableLanguages = rawLanguages
  .split(',')
  .map((lang) => lang.replace(/"/g, '').trim());

// in seconds
export const cacheTimeouts = {
  payWay: 10,
  payMethodPayWays: 10,
  payMethods: 10,
  warning: 20,
  description: 20,
  manual: 20,
};

export const invoiceStatuses = {
  success: 1,
  fail: 2,
  inProcess: 3,
};

export const langOptions = [
  {
    value: 'ru',
    label: 'Русский',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'kk',
    label: 'Қазақ',
  },
  {
    value: 'uz',
    label: "O'zbek",
  },
  {
    value: 'az',
    label: 'Azərbaycan',
  },
  {
    value: 'ky',
    label: 'Кыргызча',
  },
  {
    value: 'de',
    label: 'Deutsch',
  },
  {
    value: 'tr',
    label: 'Türkçe',
  },
  {
    value: 'ka',
    label: 'ქართული',
  },
  {
    value: 'es',
    label: 'Español',
  },
  {
    value: 'pt',
    label: 'Português',
  },
];

export const displayedLangOptions = langOptions.filter((lang) =>
  availableLanguages.includes(lang.value)
);
